function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    box-sizing: border-box;\n\n    @media (max-width: ", ") {\n      margin: 0;\n      padding: ", ";\n      width: 100%;\n    }\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import styled, { css } from "styled-components";
import { NotificationStack as BaseNotificationStack } from "@diana-ui/notification";
import "./Notification";
export default styled(BaseNotificationStack)((_ref) => {
  var {
    theme
  } = _ref;
  return css(_templateObject(), "".concat(theme.breakpoints.MOBILE_2, "px"), theme.spaceUnit.md);
});